import React from 'react';
import ConnectWalletMessage from './ConnectWalletMessage';
import { useAlgo } from '../hooks/useAlgo';
import TraitSwap from './TraitSwap';

const TraitSwapPage = () => {
  const { address } = useAlgo();

  if (!address) {
    return (
      <div className='flex justify-center mt-12'>
        <ConnectWalletMessage />
      </div>
    );
  }

  return (
    <div>
      <TraitSwap />
    </div>
  );
};

export default TraitSwapPage;
